
import Vue from 'vue';
export default Vue.extend({
  name: 'BackButton',
  props: {
    text: {
      type: String,
      default: ''
    }
  },
  methods: {
    goBack(): void {
      this.$router.back();
    }
  }
});
